import { useEffect } from 'react';
import { useDocumentHead } from '@/shared/hooks/useDocumentHead';
import { trackRumAction } from '@/shared/observability/rum';
import { CareScoutWidget } from '@/features/care-costs/components/CareScoutWidget';
import { CareCostsHeader } from '../components/CareCostsHeader';
import { CareTypeCards } from '../components/CareTypeCards';
import { CareCostsFooter } from '../components/CareCostsFooter';
import { CARESCOUT_ATTRIBUTION } from '../constants/careCosts.constants';

export const CareCostsPage = () => {
  useDocumentHead({
    title: 'Cost of Care | bQuest',
    description:
      'See what long-term care costs in your area. Explore estimates for home care, assisted living, nursing homes, and more — free, no login required.',
  });

  // RUM-01: care_cost_page_view fires for the public page only. The widget is
  // reused on dashboards, so this lives on the page (not inside the widget) to
  // keep dashboard tab views out of this metric.
  useEffect(() => {
    trackRumAction('care_cost_page_view', { viewportWidth: window.innerWidth });
  }, []);

  return (
    <div className="bg-background">
      <div className="container max-w-3xl px-4 md:px-6 py-8 md:py-12 space-y-12">
        <CareCostsHeader />
        <section>
          <CareScoutWidget />
          <p className="mt-3 text-sm font-normal leading-relaxed text-muted-foreground">
            {CARESCOUT_ATTRIBUTION}
          </p>
        </section>
        <CareTypeCards />
        <CareCostsFooter />
      </div>
    </div>
  );
};
